/* eslint-disable */
import React from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Button, Image } from '@edx/paragon';
import { Search } from '@edx/paragon/icons';
import { baseAppUrl, getBaseUrl } from 'data/services/lms/urls';

import emptyCourseSVG from 'assets/empty-course.svg';
import { reduxHooks } from 'hooks';

import messages from './messages';
import NoCourses from '../../../../public/nocourses.svg'
import arrow from '../../../../public/arrow-back.svg'
import './index.scss';

export const NoCoursesView = () => {
  const { formatMessage } = useIntl();
  const { courseSearchUrl } = reduxHooks.usePlatformSettingsData();
  
  return (
    <>
      <div className="r4c-no-courses-content">
        <div className='r4c-no-courses-image-wrapper'>
          <img src={NoCourses} alt="no courses image"  className='r4c-no-course-img'/>
        </div>
        <div className='r4c-no-courses-text-wrapper'>
          <h3 className='r4c-no-courses-header'>You are not enrolled in any micro-programme or micro-credential yet</h3>
          <p className='r4c-no-courses-text'></p>
          <div className="r4c-no-courses-btn-container">
          <a href={getBaseUrl() + "/programs/"}>
              <button className='r4c-dashboard-nocourse-btn'>
                Enroll in micro-programmes <img src={arrow} alt="arrow icon" /> 
              </button>
            </a>
            <a href={baseAppUrl(courseSearchUrl)}>
              <button className='r4c-dashboard-nocourse-btn'>
                Enroll in micro-credentials <img src={arrow} alt="arrow icon" /> 
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
    // <div
    //   id="no-courses-content-view"
    //   className="d-flex align-items-center justify-content-center mb-4.5"
    // >
    //   <Image src={emptyCourseSVG} alt={formatMessage(messages.bannerAlt)} />
    //   <h1>
    //     {formatMessage(messages.lookingForChallengePrompt)}
    //   </h1>
    //   <p>
    //     {formatMessage(messages.exploreCoursesPrompt)}
    //   </p>
    //   <Button
    //     variant="brand"
    //     as="a"
    //     href={baseAppUrl(courseSearchUrl)}
    //     iconBefore={Search}
    //   >
    //     {formatMessage(messages.exploreCoursesButton)}
    //   </Button>
    // </div>
  );
};

export default NoCoursesView;
